import type { LeadsType } from "app/pages/sales-intelligence/domain/leads/types/lead";

import type { LeadsSearchRequestDto } from "../../types";
import type { LeadDetailedResultsRequestDto, LeadDomainsSearchResultsParams } from "../../types/dto";

const LEADS_SEARCH_BASE_KEY = "leads-search";

const TABLE_DATA_QUERY_KEY = "table-data";

const COMPANY_DOMAINS_QUERY_KEY = "companies:domains";

const DOMAINS_DETAILED_RESULTS_QUERY_KEY = "detailed-results";

const COLUMN_CONFIG_QUERY_KEY = "column-config";

const COLUMN_SELECTION_QUERY_KEY = "column-selection";

const COLUMN_SELECTION_MUTATION_KEY = "column-selection-mutation";

const COMPANIES_SEARCH_COUNT_QUERY_KEY = "companies-search-count";

export const leadsSearchQueryKeys = {
    all() {
        return [LEADS_SEARCH_BASE_KEY] as const;
    },

    tableData() {
        return [...leadsSearchQueryKeys.all(), TABLE_DATA_QUERY_KEY] as const;
    },

    companyDomains({ domain, dto, entityId }: LeadDomainsSearchResultsParams) {
        return [...leadsSearchQueryKeys.tableData(), COMPANY_DOMAINS_QUERY_KEY, entityId, domain, dto] as const;
    },

    detailedResults(leadsType: LeadsType, dto?: LeadDetailedResultsRequestDto) {
        if (dto) {
            return [...leadsSearchQueryKeys.tableData(), DOMAINS_DETAILED_RESULTS_QUERY_KEY, leadsType, dto] as const;
        }

        return [...leadsSearchQueryKeys.tableData(), DOMAINS_DETAILED_RESULTS_QUERY_KEY, leadsType] as const;
    },

    columnConfig() {
        return [...leadsSearchQueryKeys.all(), COLUMN_CONFIG_QUERY_KEY] as const;
    },

    columnSelection() {
        return [...leadsSearchQueryKeys.all(), COLUMN_CONFIG_QUERY_KEY, COLUMN_SELECTION_QUERY_KEY] as const;
    },

    columnSelectionMutation() {
        return [...leadsSearchQueryKeys.all(), COLUMN_SELECTION_MUTATION_KEY] as const;
    },

    companiesSearchCount(requestDto: LeadsSearchRequestDto) {
        return [...leadsSearchQueryKeys.all(), COMPANIES_SEARCH_COUNT_QUERY_KEY, requestDto] as const;
    },
} as const;
